/**
 * UI-side character lookup. Reads the same characters.json the engine reads
 * so display names and ability text stay in lockstep.
 */

import charactersJson from "../../../spec/game-spec/data/characters.json";

interface RawCharacter {
  id: string;
  name: string;
  ability_summary: string;
  types: string[];
  wave: number;
}

const CHARACTERS = (charactersJson as { characters: RawCharacter[] }).characters;
const BY_ID = new Map(CHARACTERS.map((c) => [c.id, c]));

export function characterName(id: string | null | undefined): string | null {
  if (!id) return null;
  return BY_ID.get(id)?.name ?? id;
}

export function characterAbility(id: string | null | undefined): string | null {
  if (!id) return null;
  return BY_ID.get(id)?.ability_summary ?? null;
}
